import { render, staticRenderFns } from "./AccountsBrowse.vue?vue&type=template&id=22e4f7f6&"
import script from "./AccountsBrowse.vue?vue&type=script&lang=js&"
export * from "./AccountsBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports